import React, { useState } from "react";
import { Form,InputGroup } from "react-bootstrap";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import "./SliderView.scss";

const SliderView = (props) => {
  const {
    title,
    formatLabel,
    value,
    max,
    min,
    step,
    onChange,
    disabled,
    hideLabel,
    withInput,
    appendText,
    withInputZero
  } = props;
  
  const  restrictAlphabets = (e)=>{
    var x = e.which || e.keycode;
    if(!(x>=46 && x<=57))
      e.preventDefault()
    
  }
  return (
    <>
      <Form.Group>
        <Form.Label>
          {title} {props.tutorial}
        </Form.Label>
        {!hideLabel && <div>{(formatLabel && formatLabel(value)) || value}</div>}
        <div>
          <InputRange
            step={step || 1}
            minValue={min || 0}
            maxValue={max || 100}
            value={value > max?max:value}
            onChange={(value) => {
              onChange && onChange(value);
            }}
            allowSameValues={true}
            formatLabel={() => ""}
            disabled={disabled || false}
          />
        </div>
        <br></br>
        {withInput && <InputGroup>
          <Form.Control
            as="input"
            type="number"
            value={(value==0)?'':value}
            onChange={(e) => {
              onChange && onChange(e.target.value);
            }}
            onKeyPress={(e) => {
               restrictAlphabets(e);
            }}
            min={0}
          ></Form.Control>
          <InputGroup.Append>
            <InputGroup.Text>{appendText?appendText:'%'}</InputGroup.Text>
          </InputGroup.Append>
        </InputGroup> }
        {withInputZero && <InputGroup>
          <Form.Control
            as="input"
            type="text"
            value={value}
            onChange={(e) => {
              onChange && onChange(e.target.value);
            }}
            onKeyPress={(e) => {
               restrictAlphabets(e,e.target.value);
            }}
          ></Form.Control>
          <InputGroup.Append>
            <InputGroup.Text>{appendText?appendText:'%'}</InputGroup.Text>
          </InputGroup.Append>
        </InputGroup> }
      </Form.Group>
    </>
  );
};

export default SliderView;
